<template>
  <div>
    <a-card class="c_primary">
      <div slot="title" class="m-display-flex space-between custom">
        <span class="cmain-title"><a-icon type="project" />&nbsp;Account Pay Kewajiban</span>
        <!-- <a-button v-show="tab_active_key == '2'" type="primary" class="cbtn-create" icon ="plus" @click="navigateTo('create')">Create</a-button> -->
      </div>

      <a-row :gutter="[8, 16]">
        <a-col :span="24">
          <a-collapse accordion>
            <a-collapse-panel key="1">
              <span slot="header">Filter</span>

              <a-row :gutter="[16, 16]">
                <a-col :xs="24" :sm="12" :md="12" :lg="5">
                  <div class="m-form-item-wrapper">
                    <label for="directorate">Direktorat</label>
                    <a-select
                      placeholder="Ex: Marketing ... "
                      class="width-full"
                      initialValue="delivered"
                      allowClear
                      v-model="pagination.directorate"
                    >
                      <a-select-option
                        v-for="item in data_directorate"
                        :key="item.id"
                        :value="item.value"
                        >{{ item.label }}</a-select-option
                      >
                    </a-select>
                  </div>
                </a-col>

                <a-col :xs="24" :sm="12" :md="12" :lg="5">
                  <div class="m-form-item-wrapper">
                    <label for="tanggalTransaksi">Tgl Kewajiban</label>
                    <a-range-picker v-model="dates" @change="onChangeDateFilter"/>
                  </div>
                </a-col>

                <a-col :xs="24" :sm="12" :md="12" :lg="5">
                  <div class="m-form-item-wrapper">
                    <label for="tanggalTransaksi">Status</label>
                    <a-select
                      placeholder="Ex: Approved ... "
                      class="width-full"
                      initialValue="delivered"
                      allowClear
                      v-model="pagination.status"
                    >
                      <a-select-option
                        v-for="item in data_status"
                        :key="item"
                        :value="item"
                        >{{ item }}</a-select-option
                      >
                    </a-select>
                  </div>
                </a-col>

                <a-col :xs="24" :sm="12" :md="12" :lg="6">
                  <div class="m-form-item-wrapper">
                    <label for="tanggalTransaksi">Search</label>
                    <a-input-search
                      v-model:value="pagination.search"
                      placeholder="Quick search"
                      @search="onSearch"
                    />
                  </div>
                </a-col>
                <a-col :xs="24" :sm="12" :md="12" :lg="3">
                  <div class="m-form-item-wrapper">
                    <label style="visibility: hidden;">Action</label>
                    <a-button icon="reload" block @click="refresh">
                      Refresh
                    </a-button>
                  </div>
                </a-col>
              </a-row>              
            </a-collapse-panel>
          </a-collapse>
        </a-col>
        <a-col :span="24">
          <a-tabs v-model:activeKey="tab_active_key">
            <a-tab-pane key="1">
              <template slot="tab">
                <span>Need Process</span>&nbsp;
                <a-badge class="m-badge m-badge-small" :count="pagination_np.total" :numberStyle="{ backgroundColor: 'red' }"
                  v-if="pagination_np.total > 0">
                </a-badge>
              </template>
              <a-card class="custom-card" v-if="tab_active_key == '1'">
                <a-table 
                size="small"
                rowKey="kewajiban_id"
                :columns="columns_need_process" 
                :data-source="data_table_need_process"
                :loading="loading.table"
                :scroll="{ x: 'max-content' }"
                :pagination="pagination_np"
                @change="handleTableChange"
                class="custom-table"
                bordered>
                  <template slot="no" slot-scope="text, item, index">
                    {{ index +1 }}
                  </template>
                  <template slot="create_dt" slot-scope="text, item, index">
                    {{ moment(item.create_dt).format("YYYY-MM-DD") + ' / ' + item.tlc_create }}
                  </template>
                  <template slot="nilai" slot-scope="text, item, index">
                    {{ customFormatCurrency(item.currency, item.nilai) }}
                  </template>
                  <template slot="kurs_idr" slot-scope="text, item, index">
                    {{ customFormatCurrency('IDR', item.kurs_idr) }}
                  </template>
                  <template slot="nilai_idr" slot-scope="text, item, index">
                    {{ customFormatCurrency('IDR', (item.nilai*item.kurs_idr)) }}
                  </template>
                  <template slot="remaining_balance" slot-scope="text, item, index">
                    {{ customFormatCurrency('IDR', item.remaining_balance) }}
                  </template>
                  <template slot="action" slot-scope="text, item">
                      <div class="d-flex-container">
                          <a-button icon="eye" @click="navigateTo('manifest_np', item.kewajiban_id, item)"></a-button>
                          <a-button icon="plus" type="primary" @click="navigateTo('create_ap_np', item.reminder_ap_id, item)">Create</a-button>
                      </div>
                  </template>
                </a-table>
              </a-card>
            </a-tab-pane>
            <a-tab-pane key="2" tab="List AP Kewajiban" >
              <a-card class="custom-card" v-if="tab_active_key == '2'">
                <a-table 
                size="small"
                rowKey="kewajiban_ap_id"
                :columns="columns_ap" 
                :data-source="data_table"
                :loading="loading.table"
                :scroll="{ x: 'max-content' }"
                :pagination="pagination"
                @change="handleTableChange"
                class="custom-table"
                bordered>
                  <template slot="no" slot-scope="text, item, index">
                      {{ index +1 }}
                  </template>
                  <template slot="no_kewajiban" slot-scope="text, item">
                      {{ item.no_kewajiban }}
                  </template>
                  <template slot="create_dt" slot-scope="text, item">
                      {{ moment(item.create_dt).format("YYYY-MM-DD")+' / '+item.tlc_create }}
                  </template>
                  <template slot="tgl_kewajiban" slot-scope="text, item">
                      {{ moment(item.tgl_kewajiban).format("YYYY-MM-DD") }}
                  </template>
                  <template slot="description" slot-scope="text, item">
                      {{ item.note }}
                  </template>
                  <template slot="nilai" slot-scope="text, item">
                      {{ customFormatCurrency(item.currency, item.value_ap) }}
                  </template>
                  <template slot="kurs_idr" slot-scope="text, item">
                      {{ customFormatCurrency('IDR', item.kurs_idr) }}
                  </template>
                  <template slot="nilai_idr" slot-scope="text, item">
                      {{ customFormatCurrency('IDR', (Number(item.kurs_idr) * Number(item.value_ap))) }}
                  </template>
                  <template slot="beneficiary" slot-scope="text, item">
                      {{ item.beneficiary }}
                  </template>
                  <template slot="file_doc" slot-scope="text, item">
                      <a-button icon="file-search" size="small" @click="showModalFile(item)"></a-button>
                  </template>
                  <template slot="status" slot-scope="text, item">
                    <a-tag :color="stateColor(item.last_status)">{{ item.last_status }}</a-tag>
                  </template>
                  <template slot="action" slot-scope="text, item">
                    <div class="d-flex-container">
                      <a-button icon="edit" type="primary" @click="navigateTo('revise', item.kewajiban_ap_id)" v-if="item.last_status == 'Revised'"></a-button>
                      <a-button icon="eye" @click="navigateTo('manifest', item.kewajiban_ap_id)"></a-button>
                      <a-button type="primary" :loading="loading.relase && loading.id == item.kewajiban_ap_id" :disabled="item.last_status !== 'Approved'" @click="releaseTransaction(item)">Release</a-button>
                    </div>
                  </template>
                </a-table>
              </a-card>
            </a-tab-pane>
            <a-tab-pane key="3" tab="Cancel">
              <a-card class="custom-card" v-if="tab_active_key == '3'">
                <a-table 
                size="small"
                rowKey="kewajiban_ap_id"
                :columns="columns_ap" 
                :data-source="data_table"
                :loading="loading.table"
                :scroll="{ x: 'max-content' }"
                :pagination="pagination"
                @change="handleTableChange"
                class="custom-table"
                bordered>
                  <template slot="no" slot-scope="text, item, index">
                      {{ index +1 }}
                  </template>
                  <template slot="tgl_kewajiban" slot-scope="text, item">
                      {{ moment(item.tgl_kewajiban).format("YYYY-MM-DD") }}
                  </template>
                  <template slot="create_dt" slot-scope="text, item">
                      {{ moment(item.create_dt).format("YYYY-MM-DD")+' / '+item.tlc_create }}
                  </template>
                  <template slot="nilai" slot-scope="text, item">
                      {{ customFormatCurrency(item.currency, item.value_ap) }}
                  </template>
                  <template slot="nilai_idr" slot-scope="text, item">
                      {{ customFormatCurrency('IDR', (Number(item.kurs_idr) * Number(item.value_ap))) }}
                  </template>
                  <template slot="status" slot-scope="text, item">
                    <a-tag color="red">Canceled</a-tag>
                  </template>
                  <template slot="action" slot-scope="text, item">
                    <a-button icon="eye" @click="navigateTo('manifest', item.kewajiban_ap_id)"></a-button>
                  </template>
                </a-table>
              </a-card>
            </a-tab-pane>
            <a-tab-pane key="4" tab="AP Release">
              <a-card class="custom-card" v-if="tab_active_key == '4'">
                <a-table 
                size="small"
                rowKey="kewajiban_id"
                :columns="columns_ap" 
                :data-source="data_table"
                :loading="loading.table"
                :scroll="{ x: 'max-content' }"
                :pagination="pagination"
                @change="handleTableChange"
                class="custom-table"
                bordered>
                  <template template slot="no" slot-scope="text, item, index">
                      {{ index +1 }}
                  </template>
                  <template slot="tgl_kewajiban" slot-scope="text, item">
                      {{ moment(item.tgl_kewajiban).format("YYYY-MM-DD") }}
                  </template>
                  <template slot="create_dt" slot-scope="text, item">
                      {{ moment(item.create_dt).format("YYYY-MM-DD")+' / '+item.tlc_create }}
                  </template>
                  <template slot="nilai" slot-scope="text, item">
                      {{ customFormatCurrency(item.currency, item.value_ap) }}
                  </template>
                  <template slot="nilai_idr" slot-scope="text, item">
                      {{ customFormatCurrency('IDR', (Number(item.kurs_idr) * Number(item.value_ap))) }}
                  </template>
                  <template slot="status" slot-scope="text, item">
                    <a-tag color="green">{{ item.status == '1' ? 'Released' : '' }}</a-tag>
                  </template>
                  <template slot="action" slot-scope="text, item">
                    <a-button icon="eye" @click="navigateTo('manifest', item.kewajiban_ap_id)"></a-button>
                  </template>
                </a-table>
              </a-card>
            </a-tab-pane>
          </a-tabs>
        </a-col>
      </a-row>
    </a-card>

    <a-modal :visible="modal_file" @cancel="modalOnClose" :footer="null" :maskClosable="false" width="50%">
      <span slot="title">Document Kewajiban : [{{ state_file.no_kewajiban }}]</span>
      
      <a-list size="small" bordered :data-source="files" :loading="loading.list">
        <template #renderItem="{ file_doc, kewajiban_doc_id }">
          <a-list-item class="link-hover" @click="fileHandler(kewajiban_doc_id, file_doc)"><a-icon type="file" /> {{ file_doc }}</a-list-item>
        </template>
      </a-list>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios'
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  mixins: [CurrencyFormat],
  data(){
    const columns = [
      {
        title: 'No',
        align: 'center',
        dataIndex: 'no',
        width: 50,
        scopedSlots: { customRender: "no" },
      },
      {
        title: "No. Kewajiban",
        key: "no_kewajiban",
        width: 180,
        align: "center",
        scopedSlots: { customRender: "no_kewajiban" },
      },
      {
        title: "Tgl Buat / TLC",
        key: "tlc_create",
        width: 170,
        align: "center",
        scopedSlots: { customRender: "tlc_create" },
      },
      {
        title: "Tgl Kewajiban",
        key: "tgl_kewajiban",
        width: 170,
        align: "center",
        scopedSlots: { customRender: "tgl_kewajiban" },
      },
      {
        title: "Deskripsi",
        key: "description",
        width: 320,
        align: "left",
        scopedSlots: { customRender: "description" },
      },
      {
        title: "Nilai",
        key: "nilai",
        width: 170,
        align: "right",
        scopedSlots: { customRender: "nilai" },
      },
      {
        title: "Kurs IDR",
        key: "kurs_idr",
        dataIndex: 'kurs_idr',
        width: 170,
        align: "right",
        scopedSlots: { customRender: "kurs_idr" },
      },
      {
        title: "Beneficiary",
        key: "beneficiary",
        width: 250,
        align: "left",
        scopedSlots: { customRender: "beneficiary" },
      },
      {
        title: "Dokumen",
        key: "file_doc",
        width: 120,
        align: "center",
        fixed: "right",
        scopedSlots: { customRender: "file_doc" },
      },
      {
        title: "Status",
        key: "status",
        width: 120,
        align: "center",
        fixed: "right",
        scopedSlots: { customRender: "status" },
      },
      {
        title: "Action",
        key: "action",
        width: 120,
        align: "center",
        fixed: "right",
        scopedSlots: { customRender: "action" },
      },
    ];

    const columns_need_process = [
      {
        title: 'No',
        align: 'center',
        dataIndex: 'no',
        width: 50,
        scopedSlots: { customRender: "no" },
      },
      {
        title: "No. Kewajiban",
        key: "no_kewajiban",
        width: 180,
        align: "center",
        dataIndex: 'no_kewajiban',
        scopedSlots: { customRender: "no_kewajiban" },
      },
      {
        title: "Beneficiary",
        key: "beneficiary",
        width: 200,
        align: "left",
        dataIndex: 'beneficiary',
        scopedSlots: { customRender: "beneficiary" },
      },
      {
        title: "Deskripsi",
        key: "description",
        width: 320,
        align: "left",
        dataIndex: 'description',
        scopedSlots: { customRender: "description" },
      },
      {
        title: "Tanggal Kewajiban",
        key: "tgl_kewajiban",
        width: 180,
        align: "center",
        dataIndex: "tgl_kewajiban",
        scopedSlots: { customRender: "tgl_kewajiban" },
      },
      {
        title: "No. Invoice",
        key: "no_invoice",
        width: 180,
        align: "center",
        dataIndex: "no_invoice",
        scopedSlots: { customRender: "no_invoice" },
      },
      {
        title: "Create Date / TLC",
        key: "create_dt",
        width: 180,
        align: "center",
        scopedSlots: { customRender: "create_dt" },
      },
      {
        title: "Nilai",
        key: "nilai",
        width: 170,
        align: "right",
        scopedSlots: { customRender: "nilai" },
      },
      {
        title: "Kurs IDR",
        key: "kurs_idr",
        dataIndex: 'kurs_idr',
        width: 170,
        align: "right",
        scopedSlots: { customRender: "kurs_idr" },
      },
      {
        title: "Value (IDR)",
        key: "nilai_idr",
        dataIndex: 'nilai_idr',
        width: 170,
        align: "right",
        scopedSlots: { customRender: "nilai_idr" },
      },
      {
        title: "Balance Value (IDR)",
        key: "remaining_balance",
        dataIndex: 'remaining_balance',
        width: 170,
        align: "right",
        scopedSlots: { customRender: "remaining_balance" },
      },
      {
        title: "Action",
        key: "action",
        width: 200,
        align: "center",
        fixed: "right",
        scopedSlots: { customRender: "action" },
      },
    ];

    const columns_ap = [
      {
        title: 'No',
        align: 'center',
        dataIndex: 'no',
        width: 50,
        scopedSlots: { customRender: "no" },
      },
      {
        title: "No. AP Kewajiban",
        key: "no_kewajiban_ap",
        width: 180,
        align: "center",
        dataIndex: 'no_kewajiban_ap',
        scopedSlots: { customRender: "no_kewajiban_ap" },
      },
      {
        title: "Beneficiary",
        key: "beneficiary",
        width: 200,
        align: "left",
        dataIndex: 'beneficiary',
        scopedSlots: { customRender: "beneficiary" },
      },
      {
        title: "Deskripsi",
        key: "description",
        width: 320,
        align: "left",
        dataIndex: 'note',
        scopedSlots: { customRender: "description" },
      },
      {
        title: "Tanggal Kewajiban",
        key: "tgl_kewajiban",
        width: 180,
        align: "center",
        dataIndex: "tgl_kewajiban",
        scopedSlots: { customRender: "tgl_kewajiban" },
      },
      {
        title: "No. Invoice",
        key: "no_invoice",
        width: 180,
        align: "center",
        dataIndex: "no_invoice",
        scopedSlots: { customRender: "no_invoice" },
      },
      {
        title: "Create Date / TLC",
        key: "create_dt",
        width: 180,
        align: "center",
        scopedSlots: { customRender: "create_dt" },
      },
      {
        title: "Value AP",
        key: "nilai",
        width: 170,
        align: "right",
        scopedSlots: { customRender: "nilai" },
      },
      {
        title: "Kurs IDR",
        key: "kurs_idr",
        dataIndex: 'kurs_idr',
        width: 170,
        align: "right",
        scopedSlots: { customRender: "kurs_idr" },
      },
      {
        title: "Value AP (IDR)",
        key: "nilai_idr",
        dataIndex: 'nilai_idr',
        width: 170,
        align: "right",
        scopedSlots: { customRender: "nilai_idr" },
      },
      {
        title: "Status",
        key: "status",
        dataIndex: 'status',
        width: 150,
        align: "center",
        fixed: "right",
        scopedSlots: { customRender: "status" },
      },
      {
        title: "Action",
        key: "action",
        width: 200,
        align: "center",
        fixed: "right",
        scopedSlots: { customRender: "action" },
      },
    ];

    return {
      columns,
      columns_need_process,
      columns_ap,
      moment,
      loading: {
        table: false,
        list: false,
        id: '',
        release: false
      },
      data_table: [],
      data_directorate: [],
      data_status: ['Delivered', 'Waiting', 'On Process', 'Approved', 'Rejected', 'Revise'],
      pagination: {
        total: 0,
        search: '',
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        directorate: undefined,
        status: undefined,
        start_date: '',
        end_date: '',
        cancel_status: '0',
        release_status: '0'
      },
      pagination_np: {
        total: 0,
        search: '',
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        directorate: undefined,
        status: undefined,
        start_date: '',
        end_date: ''
      },
      files: [],
      modal_file: false,
      state_file: {},
      dates: null,
      tab_active_key: '1',
      data_table_need_process: []
    }
  },

  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatusLapUMPD",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    
  },

  mounted(){
    this.fetchDataListNeedProcess()
    this.getDirectorate()
  },

  watch: {
    tab_active_key(){
      if(this.tab_active_key == '1') this.fetchDataListNeedProcess()
      else this.fetchDataList()
    }
  },

  methods: {
    async fetchDataList(){
      try {
        this.loading.table = true

        if(this.tab_active_key == '2'){
          this.pagination.cancel_status = '0'
          this.pagination.release_status = '0'
        } else if(this.tab_active_key == '3'){
          this.pagination.cancel_status = '1'
          this.pagination.release_status = '0'
        } else if(this.tab_active_key == '4'){
          this.pagination.cancel_status = '0'
          this.pagination.release_status = '1'
        }

        const response = await axios({
          method: "GET",
          url: this.$serviceUrl + 'account_pay_kewajiban',
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
          params: this.pagination
        })
        
        this.data_table = response.data.data
        this.pagination.total = response.data.pagination.total_data
        this.loading.table = false
        
      } catch (error) {
        console.log(error);
        this.loading.table = false
        
      }
    },

    async fetchDataListNeedProcess(){
      try {
        this.loading.table = true
        const response = await axios({
          method: "GET",
          url: this.$serviceUrl + 'account_pay_kewajiban/list_need_process',
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
          params: this.pagination_np
        })
        
        this.data_table_need_process = response.data.data
        this.pagination_np.total = response.data.pagination.total_data
        this.loading.table = false
        
      } catch (error) {
        console.log(error);
        this.loading.table = false
        
      }
    },

    stateColor(state){
      if(state == '0' || state == 'On Process') return 'orange'
      else if(state == '1' || state == 'Verified' || state == 'Approved') return 'green'
      else if(state == '2' || state == 'Rejected') return 'red'
      else if(state == 'Revised') return 'orange'
      else if(state == 'Delivered') return 'blue'
    },

    stateActive(state){
      if(state == '0') return 'DRAFT'
      else if(state == '1') return 'ACTIVE'
      else if(state == '2') return 'NON ACTIVE'
    },

    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;

      this.fetchDataList();
    },
    
    showModalFile(items){
      this.state_file = items
      this.files = JSON.parse(items.files)
      this.modal_file = true
    },

    modalOnClose(){
      this.modal_file = false
    },

    async fileHandler(id, fileName){
      try {
        this.loading.list = true
        const response = await axios({
          method: "GET",
          url: this.$serviceUrl + `kewajiban/file/${id}`,
          responseType: "blob",
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          }
        })

        this.loading.list = false

        const blob = response.data;
        const mimeType = blob.type;
        const url = window.URL.createObjectURL(blob);

        // PDF atau gambar -> buka tab baru
        if (
          mimeType === "application/pdf" ||
          mimeType.startsWith("image/")
        ) {
          window.open(url, "_blank");
          return;
        }

        const link = document.createElement("a");
        link.href = url;

        const disposition = response.headers["content-disposition"];
        let filename = fileName;

        if (disposition) {
          const match = disposition.match(/filename="?(.+?)"?$/);
          if (match) {
            filename = match[1];
          }
        }

        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(url);

      } catch (error) {
        console.log(error);
        this.loading.list = false
        
      }
    },

    async getDirectorate(){
      try {
        const response = await axios({
          method: "GET",
          url: this.$serviceUrl + `kewajiban/directorate`,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          }
        })
        this.data_directorate = response.data.data
        
      } catch (error) {
        console.log(error);
        
      }
    },

    async onSearch(search){
      this.fetchDataList()
    },

    refresh(){
      if(this.tab_active_key == '1') {
        this.pagination_np.search = this.pagination.search
        this.pagination_np.directorate = this.pagination.directorate
        this.pagination_np.status = this.pagination.status
        this.pagination_np.start_date = this.pagination.start_date
        this.pagination_np.end_date = this.pagination.end_date
        this.fetchDataListNeedProcess()
      } else this.fetchDataList()
    },

    onChangeDateFilter(val){
      if(val.length > 0){
        this.pagination.start_date = this.moment(val[0]).format("YYYY-MM-DD")
        this.pagination.end_date = this.moment(val[1]).format("YYYY-MM-DD")
      } else {
        this.pagination.start_date = null
        this.pagination.end_date = null
      }
    },

    navigateTo(name, id='', payload=null){
      if(name == 'create'){
        this.$router.push({name: 'ap_kewajiban_create'})
      } else if (name == 'manifest'){
        this.$router.push({
          name: 'ap_kewajiban_manifest',
          params: {
            id: id
          }
        })
      } else if(name == 'create_ap_np'){
        this.$store.dispatch('setSelectedReminder', payload)

        this.$router.push({name: 'ap_kewajiban_create'})
      } else if (name == 'manifest_np'){
        this.$router.push({
          name: 'ap_kewajiban_need_process_manifest',
          params: {
            id: id
          }
        })
      } else if (name == 'revise'){
        localStorage.removeItem("np_id")
        this.$store.dispatch('setSelectedReminder', null)
        
        this.$router.push({
          name: 'ap_kewajiban_edit',
          params: {
            id: id
          }
        })
      }
    },

    async releaseTransaction(values){
      try {
        this.loading.release = true
        const payload = {
          manifest_id: values.kewajiban_ap_id
        }
        this.loading.id = values.kewajiban_ap_id

        const response = await axios({
          method: "POST",
          url: this.$serviceUrl + `account_pay_kewajiban/release`,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
          data: payload
        })

        this.displayMessageValue("success-other", response.data.message);
        this.loading.release = false
        this.fetchDataList()
      } catch (error) {
        this.loading.release = false
        console.log(error.response.data);
        this.displayMessageValue("error-other", error.response.data.message);
      }
    }
  }
}
</script>

<style lang="less">
.c_primary {
  .ant-card-head-title{
    margin-right: 0px!important;
  }
  .cmain-title{
    max-width: 50%;
    text-wrap: auto;
    word-break: normal;
  }
  .cbtn-create {
    i {color: #fff;}
    path{color: #fff;}
    span {color: #fff;}
  }
  .hdr_plfn{
    .ant-table-title{
      padding-bottom: 0px;
    }
  }
  .option_plfn{
    td{
    padding: 0px;
    }
  }
  .hdr_plfn_selection{
    padding: 16px;
    cursor: pointer;
  }
  .hdr_plfn_selection.isfocused  {
    background-color: fade(@color-secondary, 5%);
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25), 0 2px 8px rgba(0, 0, 0, 0.25), inset 0px 0px 0px 1px rgba(255, 255, 255, 0.1);
    border-left-style: solid;
    border-left-color: @color-secondary;
  }
  .row-ecv{
    .ant-input-number{
      justify-content: flex-end;
    }
    .ant-input-number-input{
      text-align: right;
      display: block;
    }
  }
  .row_h{
    margin-right: 11px;
  }

  .ngabango{
    background-color: fade(@color-primary, 35%);
  }
}

.cAnnualfromcreate{
  .ant-input-number-input{
    text-align: right;
    padding-right: 25px;
  }
}

.plafonformtables{
  // .ant-table-row {
    .ant-table-thead {
      background: #c1c1c1;
      font-weight: bolder;
    }
    tr:first-child {
      td:hover {
        background: #00ca8e;
      }
    }
    td:nth-child(4){
      background: #c1c1c1;
    }

    .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY) > td, 
    .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY) > td, 
    .ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY) > td, 
    .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY) > td {
      background: none;
    }

    .ant-table-thead > tr.cSUMMARY.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, 
    .ant-table-tbody > tr.cSUMMARY.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, 
    .ant-table-thead > tr.cSUMMARY:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, 
    .ant-table-tbody > tr.cSUMMARY:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
      background: #c1c1c1;
    }
  // }
}

.overvalueRow{
  background-color: fade(@color-primary, 35%);
}

.custom-card .ant-card-body {
  padding: 0px !important;
}

.custom-table .ant-table {
  border: none !important;
}

.custom-table .ant-table-container {
  border-inline-start: none !important;
  border-top: none !important;
}

.custom-table .ant-table-bordered > .ant-table-container {
  border: none !important;
}

.single-parent {
  text-transform: uppercase;
  font-weight: bold;
}

.summary-row td {
  background: #f3e8e8 !important;
  font-weight: bold;
}

.chart-container{
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress-big-text .ant-progress-text {
  font-size: 22px !important;
  font-weight: bold;
}

.footer-card {
  margin-top: 10px;
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.link-hover {
  cursor: pointer;
  color: inherit;
  text-decoration: none;
  transition: color .2s ease;
}

.link-hover:hover {
  color: #1677ff;
  text-decoration: underline;
}

.d-flex-container {
  display: flex;
  gap: 8px;
  justify-content: center;
}

</style>